import React, { PropsWithChildren } from "react";
import { Grid, Typography } from "@material-ui/core";

type StepLayoutProps = { title: string, description: React.ReactNode };

const StepLayout: React.FC<PropsWithChildren<StepLayoutProps>> = ({ title, description, children }) =>
  <Grid item container spacing={2}>
    <Grid item xs={12}>
      <Typography variant="h5">{title}</Typography>
      <hr />
      {description}
    </Grid>
    {children}
  </Grid>;

export default StepLayout;
